import { guaranteedGetUserMediaException, NoTrackError, setContentHint, } from "./utils";
import { Logger } from "../../Logger";
import { metricsManager as globalsMetricsManager } from "../../Globals";
import { DEFAULT_VIDEO_CAPTURE_FPS, DEFAULT_VIDEO_CAPTURE_HEIGHT, DEFAULT_VIDEO_CAPTURE_WIDTH, } from "gather-video-common/dist/src/public/settings";
import { Err, Ok } from "gather-common-including-video/dist/src/public/result";
export var ResolutionScaleDownFactor;
(function (ResolutionScaleDownFactor) {
    ResolutionScaleDownFactor[ResolutionScaleDownFactor["Full"] = 1] = "Full";
    ResolutionScaleDownFactor[ResolutionScaleDownFactor["Half"] = 2] = "Half";
    ResolutionScaleDownFactor[ResolutionScaleDownFactor["Quarter"] = 4] = "Quarter";
})(ResolutionScaleDownFactor || (ResolutionScaleDownFactor = {}));
export const getVideoConstraints = ({ device, scaleDown, }) => {
    const sanitizedScaleDownFactor = Math.max(scaleDown?.base ?? ResolutionScaleDownFactor.Full, scaleDown?.dynamic ?? scaleDown?.base ?? ResolutionScaleDownFactor.Full);
    const constraints = {
        width: {
            max: DEFAULT_VIDEO_CAPTURE_WIDTH,
            ideal: DEFAULT_VIDEO_CAPTURE_WIDTH / sanitizedScaleDownFactor,
        },
        height: {
            max: DEFAULT_VIDEO_CAPTURE_HEIGHT,
            ideal: DEFAULT_VIDEO_CAPTURE_HEIGHT / sanitizedScaleDownFactor,
        },
        frameRate: DEFAULT_VIDEO_CAPTURE_FPS,
    };
    if (device?.deviceId) {
        constraints.deviceId = { exact: device.deviceId };
    }
    return constraints;
};
const getVideoStreamOrThrow = async (settings) => {
    const constraints = { video: getVideoConstraints(settings) };
    Logger.info("[LMM] calling getUserMedia with ", JSON.stringify(constraints));
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    const is180p = typeof constraints.video.width !== "number" &&
        constraints.video.width?.ideal ===
            DEFAULT_VIDEO_CAPTURE_WIDTH / ResolutionScaleDownFactor.Quarter;
    globalsMetricsManager.setAttribute("capture180p", is180p ? "true" : "false");
    setContentHint(stream.getVideoTracks()[0], is180p ? "detail" : "motion");
    return stream;
};
export const getVideoStreamWithErrors = async (settings) => {
    try {
        const stream = await getVideoStreamOrThrow(settings);
        Logger.info("[LMM] Fetching video track from stream");
        const video = stream.getVideoTracks()[0];
        if (!video)
            return { video: Err(new NoTrackError()) };
        if (video) {
            globalsMetricsManager.setAttribute("selected-video-device-label", video.label);
        }
        return { video: Ok(video) };
    }
    catch (e) {
        const error = guaranteedGetUserMediaException(e);
        return { video: Err(error) };
    }
};
//# sourceMappingURL=Video.js.map